import React, {useState} from 'react'
import { Link } from "gatsby"
import './navbar.css'
import '../uxanimate.css'
import ic_contrast from '../../images/ic_contrast.svg';
import ic_contrast_dark from '../../images/ic_contrast_dark.svg';

const Navbar = ({ siteTitle, clickHandler }) => {

  const [hamburgerClicked, setHamburger] = useState(false);
  const [con, setCon] = useState(true);

  const hamburgerClick = () => {
      setHamburger(!hamburgerClicked)
  }

  function handleContrast() {
    setCon(!con);
    changeColors();
    clickHandler(con);
  }

  function changeColors(){
    var head = document.getElementsByTagName('header')[0];
    var logo = document.getElementById('logo');
    var line_a = document.getElementById('line_a');
    var line_b = document.getElementById('line_b');
    var line_c = document.getElementById('line_c');
    if (con){ //light theme
      head.className='light';
      logo.className += ' light';
      line_a.className += ' light';
      line_b.className += ' light';
      line_c.className += ' light';
      var elems = document.querySelectorAll('.nav__elem.uxanimate__fadeInOnHover');
      for (let i=0; i<elems.length; i++){
        elems[i].className += ' light';
      }
    } else {
      head.className = '';
      logo.className = 'nav__logo';
      line_a.className = 'line-f';
      line_b.className = 'line-mid';
      line_c.className = 'line-s';
      var elemslight = document.querySelectorAll('.nav__elem.uxanimate__fadeInOnHover.light');
      for (let j=0; j<elemslight.length; j++){
        elemslight[j].className = 'nav__elem uxanimate__fadeInOnHover';
      }
    }
  }

  function onKeyDown(ev){
    if(ev.keyCode===13){
      this.focus();
    }
  }

  return (
    <>
      <header>
        <div className="nav__container" >
        <div id='logo' className="nav__logo">
          <Link to="/">{siteTitle}</Link>
        </div>
        <ul role='navigation' id='nav__links__id' className={hamburgerClicked ? 'nav__links__resp' : 'nav__links'}>
          <li id='nav__sec__start' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing current' : 'nav__elem uxanimate__fadeInOnHover current'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__start">Start</Link></div></li>
          <li id='nav__sec__whyux' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__whyux">Czym jest UX?</Link></div></li>
          <li id='nav__sec__history' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__history">Historia</Link></div></li>
          <li id='nav__sec__numbers' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__numbers">UX w liczbach</Link></div></li>
          <li id='nav__sec__animation' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__animation">Animacje</Link></div></li>
          <li id='nav__sec__seo' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__seo">UX i SEO</Link></div></li>
          <li id='nav__sec__web' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__web">UX i Web design</Link></div></li>
          <li id='nav__sec__survey' className={hamburgerClicked ? 'nav__elem__resp uxanimate__spacing' : 'nav__elem uxanimate__fadeInOnHover'}><div className="uxanimate__fadeInOnHoverIn"><Link to="/#sec__survey">Ankieta</Link></div></li>
          <li className={hamburgerClicked ? 'nav__elem__resp icon' : 'nav__elem icon'}><div role="button" tabIndex={0} onKeyDown={onKeyDown} aria-label="Contrast button menu" onClick={handleContrast}><img src={con ? ic_contrast : ic_contrast_dark} alt='contrast icon'/></div></li>
        </ul>
        <div role="button" tabIndex={0} onKeyDown={onKeyDown} aria-label="Hamburger button menu" className="hamburger" onClick={hamburgerClick}>
          <div id='line_a' className="line-f"></div>
          <div id='line_b' className="line-mid"></div>
          <div id='line_c' className="line-s"></div>
        </div>
        </div>
      </header>
    </>
  )
}

export default Navbar